import { gql } from "@apollo/client";

export const GET_AUTORIZACION_CONTROL = gql`
query GetAutorizacionControl($idEvaluacion: Int!, $idEvento: Int!) {
  autorizacionControl (idEvaluacion: $idEvaluacion, idEvento: $idEvento) {
    idEvaluacion,
    idAutorizacionControl,
    idEstado
  }
}
`;